import React, { createContext, useContext, useMemo, useState, useEffect } from "react";

const UiContext = createContext(null);

export function UiProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    try { return JSON.parse(localStorage.getItem("meten_darkMode") || "false"); }
    catch { return false; }
  });

  const [showAdvanced, setShowAdvanced] = useState(() => {
    try { return JSON.parse(localStorage.getItem("meten_showAdvanced") || "true"); }
    catch { return true; }
  });

  const [showTooltips, setShowTooltips] = useState(() => {
    try { return JSON.parse(localStorage.getItem("meten_showTooltips") || "true"); }
    catch { return true; }
  });

  useEffect(() => { localStorage.setItem("meten_darkMode", JSON.stringify(darkMode)); }, [darkMode]);
  useEffect(() => { localStorage.setItem("meten_showAdvanced", JSON.stringify(showAdvanced)); }, [showAdvanced]);
  useEffect(() => { localStorage.setItem("meten_showTooltips", JSON.stringify(showTooltips)); }, [showTooltips]);

  const value = useMemo(() => ({
    darkMode, setDarkMode,
    showAdvanced, setShowAdvanced,
    showTooltips, setShowTooltips,
  }), [darkMode, showAdvanced, showTooltips]);

  return <UiContext.Provider value={value}>{children}</UiContext.Provider>;
}

export function useUi() {
  const ctx = useContext(UiContext);
  if (!ctx) throw new Error("useUi must be used inside <UiProvider>");
  return ctx;
}
